<template>
  <googlemaps-marker
    ref="marker"
    :icon="icon"
    :label="label"
    :position="position"
    :z-index="zIndex"
    @click="handleClick"
  />
</template>

<script>
/* global google */
import { MapElement } from 'vue-googlemaps';

export default {
  mixins: [MapElement],

  props: {
    username: {
      type: String,
      required: true,
    },
    position: {
      type: Object,
      required: true,
    },
    zIndex: {
      type: Number,
      default: null,
    },
  },

  computed: {
    user() {
      return this.$store.getters['users/getUserByUsername'](this.username);
    },

    participateInCurrentCall() {
      return this.$store.getters['voip/participateInCurrentCall'](
        this.username
      );
    },

    userLabel() {
      if (this.user) {
        if (this.user.type === 'bus') {
          return this.user.details.vehicle_no;
        } else if (this.user.type === 'inspector') {
          return this.user.details.matricule;
        }
      }
      return '?';
    },

    icon() {
      const inspectorPin =
        'm18.5890625 21.471875 12.8125-8.471875 12.815625 8.471875h12.7828125v22.8578125h-12.6140625v.10625l-12.984375 7.0515625-12.990625-7.05625v-.1015625h-11.4109375v-22.8578125z';
      const busPin =
        'M18.1,43.3H7V20.4h11.4c3.3-3.8,8.1-6.2,13.6-6.2c5.4,0,10.3,2.4,13.6,6.2H57v22.9H45.9c-3.4,4.2-8.5,6.6-13.9,6.6C26.4,49.9,21.4,47.3,18.1,43.3z';

      const colors = {
        highlight: {
          fill: '#3cb1a1',
          opacity: this.participateInCurrentCall ? '0.3' : '0',
        },
        pin: {
          fill: this.$store.getters['live/userHasFilters'](this.user)
            ? '#319B8D'
            : '#464a52',
          stroke: '#fffefb',
        },
      };

      const icon = `
        <svg height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" fill="${
            colors.highlight.fill
          }" fill-opacity="${colors.highlight.opacity}" r="32"/>
          <path d="${
            this.user && this.user.type === 'inspector' ? inspectorPin : busPin
          }" fill="${colors.pin.fill}" fill-rule="nonzero" stroke="${
        colors.pin.stroke
      }"/>
        </svg>
      `;

      return {
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(icon),
        scaledSize: new google.maps.Size(64, 64),
        anchor: new google.maps.Point(32, 32),
      };
    },

    label() {
      return {
        color: '#fff',
        text: this.userLabel,
        fontFamily: 'Nunito, sans-serif',
        fontWeight: 'bold',
      };
    },
  },

  methods: {
    handleClick() {
      this.$emit('click', {
        position: this.$refs.marker.$_marker.getPosition(),
        username: this.username,
      });
    },
  },
};
</script>
